var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditOrangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 2.60102H4.83301C3.43288 2.60102 2.73281 2.60102 2.19803 2.8735C1.72763 3.11319 1.34517 3.49564 1.10549 3.96604C0.833008 4.50082 0.833008 5.20089 0.833008 6.60102V13.601C0.833008 15.0012 0.833008 15.7012 1.10549 16.236C1.34517 16.7064 1.72763 17.0889 2.19803 17.3285C2.73281 17.601 3.43288 17.601 4.83301 17.601H11.833C13.2331 17.601 13.9332 17.601 14.468 17.3285C14.9384 17.0889 15.3208 16.7064 15.5605 16.236C15.833 15.7012 15.833 15.0012 15.833 13.601V10.101M5.83299 12.601H7.22844C7.63609 12.601 7.83992 12.601 8.03173 12.555C8.20179 12.5141 8.36436 12.4468 8.51348 12.3554C8.68168 12.2524 8.8258 12.1082 9.11406 11.82L17.083 3.85102C17.7734 3.16066 17.7734 2.04138 17.083 1.35102C16.3927 0.660664 15.2734 0.660663 14.583 1.35102L6.61404 9.31997C6.32578 9.60822 6.18166 9.75235 6.07859 9.92054C5.9872 10.0697 5.91986 10.2322 5.87904 10.4023C5.83299 10.5941 5.83299 10.7979 5.83299 11.2056V12.601Z",
    stroke: "#F37721",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOrangeIcon);
export default __webpack_public_path__ + "static/media/edit-orange-icon.78470315ef5e13a19d7bc51519ff796f.svg";
export { ForwardRef as ReactComponent };